export const NO_IMAGE_URL = '/images/no-image.png'
